<app-card>
  <ng-container header>
    <h3>Nyhedsbrev</h3>
  </ng-container>
  @if (selectedCustomerNewsletter().data; as newsletter) {
    @if (newsletter?.isSubscribedToOneToTwoEmailsAWeek || newsletter?.isSubscribedToSupervinNewsletter) {
      <div class="newsletter-status">
        <mat-icon class="success">circle</mat-icon>
        Tilmeldt
        @if (newsletter?.isSubscribedToSupervinNewsletter) {
          (Supervin nyhedsmail)
        } @else if (newsletter?.isSubscribedToOneToTwoEmailsAWeek) {
          (1-2 mails om ugen)
        }
      </div>
    } @else {
      <div class="newsletter-status">
        <mat-icon>circle</mat-icon>
        Ikke tilmeldt
      </div>
    }

    <div class="buttons">
      <div class="flex cursor-pointer" (click)="openNewsletterInfoModal()">
        <mat-icon class="material-symbols-outlined me-1">info</mat-icon>
        <p>Spørgsmål om nyhedsbrev?</p>
      </div>
      <button mat-flat-button class="btn-grey" type="submit"
              (click)="subscribeTo1To2EmailsAWeek()"
              [disabled]="newsletter?.isSubscribedToOneToTwoEmailsAWeek || newsletter?.isSubscribedToSupervinNewsletter">
        @if (loadingSubscribeToOneToTwoEmailsAWeek()) {
          <mat-spinner diameter="20"/>
        } @else {
          Tilmeld 1-2 mails om ugen
        }
      </button>
      <button mat-flat-button type="submit" class="my-3"
              (click)="subscribeToNewsletter()"
              [disabled]="newsletter?.isSubscribedToSupervinNewsletter">
        @if (loadingSubscribeToNewsletter()) {
          <mat-spinner diameter="20" class="spinner-white"/>
        } @else {
          Tilmeld nyhedsmail
        }
      </button>
    </div>
  } @else if (selectedCustomerNewsletter().loading) {
    <app-loading-icon [grey]="true" [small]="true"/>
  } @else {
    <p>Der skete en fejl. Kunden blev ikke fundet i HubSpot.</p>
  }
</app-card>
